// import Layout from "../Layout";
// import UserProfile from "../Profile";
// import UserArticles from "../Articles";
// import UserComments from "../Comments";

const Layout = () => import(/* webpackChunkName: "group-register" */ '../Layout.vue')
const UserProfile = () => import(/* webpackChunkName: "group-register" */ '../Profile.vue')
const UserArticles = () => import(/* webpackChunkName: "group-register" */ '../Articles.vue')
const UserComments = () => import(/* webpackChunkName: "group-register" */ '../Comments.vue')

export default [
  { path: "/user", name: "user", component: Layout, title: "user", redirect: { name: "userprofile" }, meta: { requiresAuth: true },
    children: [
      { path: "userprofile", name: "userprofile", component: UserProfile },
      { path: "userarticles", name: "userarticles", component: UserArticles },
      { path: "usercomments", name: "usercomments", component: UserComments },
      { path: "*", redirect: "user" }
    ]
  }
];
